

















import { Component, Vue, Prop } from 'vue-property-decorator';

import config from '../utils/config';
import CardWarningMessage from './CardWarningMessage.vue';

@Component({
  components: {
    CardWarningMessage,
  },
})
export default class EmptyEventMessageComponent extends Vue {
  @Prop({ default: 'Inscrições' })
  private resourceName!: string;

  @Prop({ default: 'Inscrições' })
  private alias!: string;

  get url() {
    return `${config.getFrontAddress()}/${this.alias}/sign-up`;
  }
}
